// timer.service.ts
import { Injectable } from '@angular/core';
import { Observable, interval } from 'rxjs';
import { map, shareReplay, startWith, takeWhile } from 'rxjs/operators';

export interface CountdownTime {
   days: number;
   hours: number;
   minutes: number;
   seconds: number;
   expired: boolean;
}

@Injectable({ providedIn: 'root' })
export class CountdownTimerService {
   createCountdown(endDate: Date): Observable<CountdownTime> {
      return interval(1000).pipe(
         startWith(0),
         map(() => {
            const now = Date.now();
            const distance = endDate.getTime() - now;

            if (distance <= 0) {
               return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
            }

            return {
               days: Math.floor(distance / (1000 * 60 * 60 * 24)),
               hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
               minutes: Math.floor((distance / (1000 * 60)) % 60),
               seconds: Math.floor((distance / 1000) % 60),
               expired: false
            };
         }),

         // ✅ auto-complete when expired
         takeWhile(t => !t.expired, true),

         // ✅ ensures clean resubscription when observable is replaced
         shareReplay({ bufferSize: 1, refCount: true })
      );
   }
}
